export default __webpack_public_path__ + "static/media/151-hand-phones.c6d6b738.png";